const GOOGLE_ANALYTICS_ID = 'G-FM529D7GCJ';
const GOOGLE_ANALYTICS_SCRIPT_ID = 'google-analytics-gtag';

let googleAnalyticsLoaded = false;

const deleteCookie = (name) => {
	if (typeof window === 'undefined' || typeof document === 'undefined') {
		return;
	}

	const hostnameParts = window.location.hostname.split('.');
	const domains = [
		window.location.hostname,
		`.${window.location.hostname}`,
		hostnameParts.length > 2 ? `.${hostnameParts.slice(1).join('.')}` : null,
	].filter(Boolean);

	const expire = `${name}=; Max-Age=0; expires=Thu, 01 Jan 1970 00:00:00 GMT; Path=/; SameSite=Lax`;
	document.cookie = expire;
	domains.forEach((domain) => {
		document.cookie = `${expire}; Domain=${domain}`;
	});
};

const deleteGoogleAnalyticsCookies = () => {
	deleteCookie('_ga');
	deleteCookie(`_ga_${GOOGLE_ANALYTICS_ID.replace('G-', '').replace(/-/g, '_')}`);
};

export const GoogleAnalyticsService = {
	load() {
		if (typeof window === 'undefined' || typeof document === 'undefined') {
			return;
		}

		if (googleAnalyticsLoaded) {
			return;
		}

		window[`ga-disable-${GOOGLE_ANALYTICS_ID}`] = false;
		window.dataLayer = window.dataLayer || [];
		window.gtag = window.gtag || function() {
			window.dataLayer.push(arguments);
		};

		if (!document.getElementById(GOOGLE_ANALYTICS_SCRIPT_ID)) {
			const script = document.createElement('script');
			script.id = GOOGLE_ANALYTICS_SCRIPT_ID;
			script.async = true;
			script.src = `https://www.googletagmanager.com/gtag/js?id=${GOOGLE_ANALYTICS_ID}`;
			document.head.appendChild(script);
		}

		window.gtag('js', new Date());
		window.gtag('config', GOOGLE_ANALYTICS_ID);
		googleAnalyticsLoaded = true;
	},

	unload() {
		if (typeof window === 'undefined' || typeof document === 'undefined') {
			return;
		}

		window[`ga-disable-${GOOGLE_ANALYTICS_ID}`] = true;
		googleAnalyticsLoaded = false;

		const script = document.getElementById(GOOGLE_ANALYTICS_SCRIPT_ID);
		if (script) {
			script.remove();
		}

		deleteGoogleAnalyticsCookies();
	},

	syncWithConsent(cookiesAccepted) {
		if (cookiesAccepted === true) {
			this.load();
			return;
		}

		if (cookiesAccepted === false) {
			this.unload();
		}
	},
};
